import { defineNuxtPlugin } from '#app'
import { useLayoutStore } from '#imports'

export default defineNuxtPlugin({
  parallel: true,
  async setup () {
    // console.log('[NUXT] 20.init.client.js')
    const layout = useLayoutStore()

    await layout.checkSupports()
    // do anything client only here
  }
})
